import { render } from "./CommentList.vue?vue&type=template&id=9d57944a&scoped=true"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"

import "./CommentList.vue?vue&type=style&index=0&id=9d57944a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d57944a"]])

export default __exports__